const state = {

    valid: new Map(), //afr house单校验结果是否通过

}

const mutations = {
    // 设置基本信息
    setValid: (state, data) => {
        state.valid.set(data.i,data.flag)

    },
    deleteValid:(state, data)=>{
        state.valid.delete(data.i)
    }

}

const actions = {
    //house单信息
    setValid(context, data) {
        console.log(data,11)

        context.commit("setValid", data)
    },
    deleteValid(context, data){
        context.commit("deleteValid", data)

    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
